import type { Layout } from "../tokens.ts";

/** Today's klarity-doc.js look. CSS values are measured from the Word reference PDFs (plan 02, "Word spacing model"). */
export const technicalLayout: Layout = {
  key: "technical",
  name: "Technical",
  cover: [
    '<img class="kl-cover-logo" src="{{logo.cover}}" alt="">',
    '<p class="kl-cover-code">{{code}}</p>',
    '<p class="kl-cover-subtitle">{{subtitle}}</p>',
    '<p class="kl-cover-doctype">{{docType}}</p>',
    '<p class="kl-cover-classification">{{classification}}</p>',
    '<p class="kl-cover-date">{{date}}{{#version}}  ·  {{version}}{{/version}}</p>',
  ].join("\n"),
  header:
    '<table class="kl-hf kl-hf-header"><tr><td class="kl-hf-left"><img class="kl-header-logo" src="{{logo.header}}" alt=""></td><td class="kl-hf-right">{{title}}</td></tr></table>',
  footer:
    '<table class="kl-hf kl-hf-footer"><tr><td class="kl-hf-left">{{classification}}</td><td class="kl-hf-right"><span class="kl-page-number"></span></td></tr></table>',
  css: `/* Body pages: the Word header (logo line + rule + 6pt after) ends at 76.24pt, so content after a natural page
   break starts there (an h1 at the top of such a page has its baseline at 88.32 = 76.24 + 11.98 + grid). The first
   body page starts 2.84pt higher: its first h1 baseline is at 105.36 = 73.4 + 20 (firstBefore h1) + 11.98. */
@page { margin-top: 76.24pt; }
.kl-body { margin-top: -2.84pt; }
/* Header logo: 60 x 42 px in legacy docx = 45 x 31.5pt, text baseline on the image bottom. */
.kl-header-logo { width: 45pt; height: 31.5pt; vertical-align: baseline; }
/* Word repeats the cell's top margin on the continuation of a row that splits across pages. */
.kl-table td { box-decoration-break: clone; }
/* The legacy tables are Word "autofit" tables: a column grows to its longest unbreakable word and the others give
   the space back, which is what CSS auto table layout does with the percentage widths as preferences. */
.kl-table { table-layout: auto; }
/* Cover: Word logo box 225.6-374.0pt, baselines 431.52 / 458.88 / 479.28 / 542.88 / 558.24pt. */
.kl-cover { padding-top: 171.6pt; text-align: center; }
.kl-cover-logo { display: block; width: 210pt; height: 148.4pt; margin: 0 auto; }
.kl-cover .kl-cover-code { margin-top: 31.7pt; font-size: var(--kl-size-title); font-weight: bold; color: var(--kl-primary); }
.kl-cover .kl-cover-subtitle { margin-top: 6.2pt; font-size: var(--kl-size-cover-subtitle); font-weight: bold; color: var(--kl-accent); }
.kl-cover .kl-cover-doctype { margin-top: 5.7pt; font-size: var(--kl-size-cover-doctype); color: var(--kl-muted); }
.kl-cover .kl-cover-classification { margin-top: 51.6pt; font-style: italic; color: var(--kl-muted); }
.kl-cover .kl-cover-date { margin-top: 3.9pt; color: var(--kl-muted); }
`,
};
